import React from 'react';

import {BulkActionTool} from 'src/components/bulk-tool';
import {
    bulkDischargeUsersEntitlements,
    getDischargeUsersEntitlementsProgress,
    stopBulkActions,
} from 'src/openapi/admin/apis/BulkDischargeUsersEntitlementsApi';
import {useAppDispatch} from 'src/store/hooks';

import {MODAL_WIDTH} from '../constants';
import {UpdateUsersEntitlementsModal} from '../update-users-entitlements.modal';

import {
    TOOL_PROGRESS_LABEL,
    TOOL_STACK_OVERFLOW_MESSAGE,
    TOOL_TASK,
    TOOL_TITLE,
} from './constants';
import {
    selectDischargeUsersEntitlementsBulkUuid,
    selectDischargeUsersEntitlementsTask,
    setBackgroundTask,
    setShown,
    setUuid,
} from './discharge-users-entitlements.slice';

import type {UpdateEntitiesEntitlementsRelation} from 'src/openapi/admin/models/UpdateEntitiesEntitlementsRelation';

type Props = {
    ids: string[],
    shown: boolean,
    onClose: () => void,
};

export const DischargeUsersEntitlementsTool = ({ids, shown, onClose}: Props) => {
    const apiDispatch = useAppDispatch();

    return (
        <BulkActionTool<UpdateEntitiesEntitlementsRelation>
            shown={shown}
            onClose={onClose}
            width={MODAL_WIDTH}

            toolTask={TOOL_TASK}
            toolName={TOOL_TITLE}
            progressLabel={TOOL_PROGRESS_LABEL}

            taskSelector={selectDischargeUsersEntitlementsTask}
            uuidSelector={selectDischargeUsersEntitlementsBulkUuid}

            setUuid={setUuid}
            setTask={setBackgroundTask}
            setResultShown={setShown}
            saveActionRequest={(updateEntitiesEntitlementsRelation, options) => (
                apiDispatch(bulkDischargeUsersEntitlements({...options, updateEntitiesEntitlementsRelation}))
            )}
            getProgress={id => apiDispatch(getDischargeUsersEntitlementsProgress({id}))}
            stopAction={id => apiDispatch(stopBulkActions({id}))}

            stackOverflowMessage={TOOL_STACK_OVERFLOW_MESSAGE}>
            {({processAction, onCloseModal}) => (
                <UpdateUsersEntitlementsModal
                    ids={ids}
                    mode="DISCHARGE"
                    onCloseModal={onCloseModal}
                    processAction={processAction}
                />
            )}
        </BulkActionTool>
    );
};
